import { BackendFactory } from "dnd-core";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";

// TODO: move the higher level drag n drop stuff out
export const DnDItemTypes = {
  TAB: "tab",
};
// simple way to check whether the device support touch (it doesn't check all fallback, it supports only modern browsers)
const isTouchDevice = () => {
  if ("ontouchstart" in window) {
    return true;
  }
  return false;
};
// Assigning backend based on touch support on the device
export const backendForDND: BackendFactory = isTouchDevice()
  ? TouchBackend
  : HTML5Backend;
